import { render, staticRenderFns } from "./SIdentify.vue?vue&type=template&id=4b406afa&scoped=true&"
import script from "./SIdentify.vue?vue&type=script&lang=js&"
export * from "./SIdentify.vue?vue&type=script&lang=js&"
import style0 from "./SIdentify.vue?vue&type=style&index=0&id=4b406afa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b406afa",
  null
  
)

export default component.exports